import { userApi } from '@api/user/user.api';

export const {
  useLazyLoadMetaQuery,
  useSaveMetaMutation,
  useLoadProfileQuery,
  useSaveProfileMutation,
  useLoadSettingsQuery,
  useSaveSettingsMutation,
  useLazyLoadProfileQuery,
  useLoadMfaQuery,
  useLazyLoadMeQuery,
  useSaveGuidesMutation,
} = userApi;
